import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6">
      <p className="text-6xl font-bold text-primary-200 tracking-tighter mb-4">404</p>
      <div className="h-12 w-12 rounded-full bg-primary-50 ring-1 ring-primary-200 flex items-center justify-center mb-4">
        <Compass className="h-6 w-6 text-primary-700" />
      </div>
      <h2 className="text-xl font-bold tracking-tight">Página no encontrada</h2>
      <p className="text-sm text-muted-foreground mt-2 max-w-md">
        La URL a la que intentas acceder no existe o fue movida.
      </p>
      <Button asChild className="mt-5">
        <Link to="/">Volver al inicio</Link>
      </Button>
    </div>
  );
}
